import { useAuthentication } from '@context/authentication.context';
import React, { FCWithChildren, useEffect, useState } from 'react';
import { useBucket } from '@context/bucket.context';
import { LDState } from '@components/bucketTest/types';
import useUser from '@hooks/user/use-user';

type PageAuthenticationGuardProps = {
  redirectionUrl?: string;
  modalType?: string;
  pageLoginIsDisabled?: boolean;
  onAuth?: () => void;
};

const PageAuthenticationGuard: FCWithChildren<PageAuthenticationGuardProps> = (props): React.JSX.Element => {
  const { redirectionUrl = '', children, pageLoginIsDisabled = false, onAuth } = props;

  const { state } = useBucket();
  const { setAuthOpen, setRedirectUrl, setOnAuth } = useAuthentication();
  const { isAuthenticated } = useUser();

  // We've encountered a bug, where if user closes the popup, the popup would reappear before the user would get redirected.
  // This state handles that situation.
  const [hasHadInitialOpening, setHasHadInitialOpening] = useState<boolean>(false);

  useEffect(() => {
    if (hasHadInitialOpening) {
      return;
    }
    if (!isAuthenticated && !pageLoginIsDisabled && [LDState.SUCCESS, LDState.FAILED].includes(state)) {
      setHasHadInitialOpening(true);
      setAuthOpen(true);

      if (typeof onAuth !== 'undefined') {
        setOnAuth(() => onAuth);
      }
    }
  }, [isAuthenticated, pageLoginIsDisabled, state, onAuth, setOnAuth]);

  useEffect(() => {
    setRedirectUrl({ url: redirectionUrl, mode: 'replace' });
  }, [isAuthenticated, redirectionUrl]);

  return <>{children}</>;
};
export default PageAuthenticationGuard;
